<template>
    <div class="faq-section spad">
      <div class="container">
        <div v-html="content"></div>
      </div>
    </div>
</template>

<script>
export default {
  data() {
    return {
      content: "",
      type: "cookies_policy",
      name: "Politique de cookies",
    };
  },
  beforeMount() {
    if (this.$route.query.type&&this.$route.query.type==="apercu") {
      this.content=this.$route.query.content;
    } else {
      this.getPageType(this.type);
    }
  },
  methods: {
    getPageType (type) {
      this.$axios({
        url: "admin/page/"+type,
        method: "GET",
      })
        .then((response) => {
          if (response.data.length>0) {
            this.content=response.data[0].content;
            this.id=response.data[0].id;
          }
        })
        .catch(function (err) {
          console.log(err.response.data);
        });
    },
  },
};
</script>
